export enum ProgressBarStatus {
  Default,
  Indeterminate,
  Error
}

export enum UploadStatus {
  UploadStarted,
  UploadFailedPost,
  UploadFailedBlocks,
  UploadFailedPatch,
  UploadFailed,
  UploadProcessing,
  UploadSuccessful
}

export interface IDragDropUploadHandlerStore {
  uploadPercent: number;
  file?: File;
  errorMessage?: string;
  uploadStatus?: UploadStatus;
  progressBarStatus?: ProgressBarStatus;
  validExtensions?: string[];

  upload(file: any): void;
  reset?(): void;
  dispose?(): void;
  setProgressBarStatus?(progressBarStatus: ProgressBarStatus): void;
}

export interface IDeferredDragDropUploadHandlerStore extends IDragDropUploadHandlerStore {
  setBuildVersion(buildVersion: string): void;
  setBuildNumber(buildNumber: string): void;
  setup(file: any): void;
  upload(): Promise<void>;
}
